import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import AppValues from 'src/app/common/app.values';
import { GridTableBody, TableCellAttribute, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { DeactivationIncident, UserBasic } from 'src/app/swagger-api';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';

@Injectable()
export class ReactivationTableFactory {
  public buildTableData(items: DeactivationIncident[]): UserTableConstructorInfo {
    return {
      header: this.getTableHeader(),
      body: this.getTableBody(items),
      attribute: this.getManageCellAttribute(),
    };
  }

  private getTableHeader(): ColumnTypes[] {
    return [ColumnTypes.USER, ColumnTypes.DATE, ColumnTypes.DEACTIVATIONS, ColumnTypes.DESCRIPTION, ColumnTypes.MANAGE];
  }

  private getManageCellAttribute(): TableCellAttribute {
    return { value_class_front: 'manage', key: 'manage' };
  }

  private convertDeactivationIncidentsToUserBasic(deactivationIncident: DeactivationIncident): UserBasic {
    return {
      user_id: deactivationIncident.profile_view.user_id,
      displayed_name: deactivationIncident.profile_view.displayed_name,
      is_admin: deactivationIncident.profile_view.is_admin,
      image_url: deactivationIncident.profile_view.image_url,
      account_status: deactivationIncident.profile_view.account_status,
    };
  }

  private getTableBody(deactivationIncidents: DeactivationIncident[]): GridTableBody[] {
    return deactivationIncidents.map((deactivationIncident: DeactivationIncident) => {
      const user: UserBasic = this.convertDeactivationIncidentsToUserBasic(deactivationIncident);
      return {
        user: user,
        entityId: user.user_id,
        actorId: user.user_id,
        created: new DatePipe('en-US').transform(
          deactivationIncident.reactivation_petition?.modified ?? deactivationIncident.modified,
          AppValues.DATE_TIME_FORMAT_SHORT,
        ),
        is_admin: user.is_admin,
        account_status: user.account_status,
        accessForAdmin: true,
        deactivations: deactivationIncident.total_account_deactivations,
        description: deactivationIncident.reactivation_petition?.user_information,
        manage: { status: null, reason: null },
      };
    });
  }
}
